import { useSearchMasterDataGudidBrand } from '@curvo/apollo'
import LoadingIndicator from '@curvo/common-ui/dist/components/Loading/Spinner'
import { LabeledValue, SelectProps } from 'antd/lib/select'
import { debounce } from 'lodash'
import React, { useState } from 'react'
import { StyledSelect, StyledSelectPropsType } from '../../Update/components/Select/common'

export const GudidBrandSelector: React.FunctionComponent<SelectProps<LabeledValue> & StyledSelectPropsType> = props => {
  const [searchText, setSearchText] = useState('')

  const { data, loading } = useSearchMasterDataGudidBrand({ variables: { input: { search: searchText } } })

  const gudidBrands = (data && data.searchGudidBrands) || []

  return (
    <StyledSelect
      onSearch={debounce(setSearchText, 800)}
      loading={loading}
      labelInValue
      showSearch
      filterOption={false}
      showArrow={false}
      defaultActiveFirstOption={false}
      placeholder="Select Gudid Brand"
      notFoundContent={loading ? <LoadingIndicator /> : 'No Data'}
      {...props}>
      {gudidBrands.map(item => (
        <StyledSelect.Option key={item}>{item}</StyledSelect.Option>
      ))}
    </StyledSelect>
  )
}
